import { FilePond } from 'react-filepond';
import { getScanStatusColor } from 'src/utils';
import styled from 'styled-components';

export const FilePondWrapper = styled.div`
  position: relative;
  cursor: pointer;
`;

export const StyledFilePond = styled(FilePond)`
  & .filepond--panel-root {
    background-color: unset;
  }

  /* Hide completed/idle files in FilePond list to avoid duplication with Custom List */
  & .filepond--item[data-filepond-item-state='processing-complete'],
  & .filepond--item[data-filepond-item-state='idle'] {
    display: none;
  }
`;

export const UploadedFileName = styled.div<{ $status?: string }>`
  font-size: 12px;
  color: ${(props) => getScanStatusColor(props.$status, props.theme)};
  font-weight: 500;
  padding: 10px 14px;
  width: 100%;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FileItemContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: 1px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.turquoise.T300
        : props.theme.atlas.semantic.color.action.primary.default};
  border-radius: 5px;
  margin-bottom: 8px;
  width: 100%;
`;

export const RemoveIcon = styled.img`
  margin: 0 14px;
  cursor: pointer;
  width: 16px;
  height: 16px;
`;

export const FilesList = styled.div`
  margin-top: 10px;
`;
